import $ from 'jquery';

export class ExtractionService {

    static SYSTEM_EXTRACTION_ID = 189;

    constructor(component) {
        this.component = component;
    }

    loadExtractions(projectId) {
        return new Promise((resolve, reject) => {
            try {
                $.get("/api/v1/projects/" + projectId + "/extractions", res => {
                    res = res == null? [] : res;
                    resolve(res);
                })
                .catch(error => {
                    reject(error);
                });
            } catch (error) {
                reject(error);
            }
        });
    }

    getExtraction(extractionId) {
        return new Promise((resolve, reject) => {
            try {
                $.get("/api/v1/extractions/" + extractionId, res => {
                    // sort the batches so the debug batch is always at the top of the list
                    res.extraction_batches.sort((a, b) => b.debug - a.debug);
                    resolve(res);
                })
                .catch(error => {
                    reject(error);
                });
            } catch (error) {
                reject(error);
            }
        });
    }

    createExtraction(projectId, name, userId) {
        return new Promise((resolve, reject) => {
            try {
                // Create new extraction object
                const newExtraction = {
                    project_id: projectId,
                    name: name,
                    user_id: userId,
                    domains: [],
                };
                // use ajax function to overide the default 400 behavior defined in main.jsx
                $.ajax({
                    url: "/api/v1/projects/" + projectId + "/extractions",
                    method: 'POST',
                    data: JSON.stringify(newExtraction),
                    contentType: 'application/json',
                    success: (res) => {
                        resolve({extraction: res, errorMessage: null});
                    },
                    statusCode: {
                        // overide the default 400 behavior defined in main.jsx
                        400: (xhr) => {
                            let errorMessage = 'Failed to create extraction';
                            if (xhr.responseText) {
                                try {
                                    const response = JSON.parse(xhr.responseText);
                                    if (response.message) {
                                        errorMessage = response.message;
                                    }
                                } catch (e) {
                                    console.log('Error parsing server response:', e);
                                }
                            }
                            resolve({extraction: null, errorMessage: errorMessage});
                        }
                    }
                }).catch(error => {
                    reject(error);
                });
            } catch (error) {
                reject(error);
            }
        });
    }

    deleteExtraction(extractionId) {
        return new Promise((resolve, reject) => {
            try {
                $.ajax({
                    url: "/api/v1/extractions/" + extractionId,
                    method: 'DELETE',
                    success: () => {
                        resolve();
                    }
                }).catch(error => {
                    reject(error);
                });
            } catch (error) {
                reject(error);
            }
        });
    }

    updateExtraction(extraction) {
        return new Promise((resolve, reject) => {
            try {
                // remove the fields that are not allowed to be updated
                let extractionToUpdate = { ...extraction, 
                    extraction_batches: [],
                    job_definitions: [],
                    extra_extraction_id: [],
                    sites: [] 
                };
                $.ajax({
                    url: "/api/v1/extractions/" + extraction.id,
                    method: 'PUT',
                    data: JSON.stringify(extractionToUpdate),
                    contentType: 'application/json',
                    success: (res) => {
                        resolve(res);
                    },
                    error: (xhr, status, error) => {
                        reject(xhr.responseText);
                    }
                }); 
            } catch (error) {
                reject(error);
            }
        });
    }
    
}